(function (f, b) {
if (!b.__SV) {
var e, g, i, h; window.mixpanel = b; b._i = []; b.init = function (e, f, c) {
function g(a, d) { var b = d.split("."); 2 == b.length && (a = a[b[0]], d = b[1]); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))) } } var a = b; "undefined" !== typeof c ? a = b[c] = [] : c = "mixpanel"; a.people = a.people || []; a.toString = function (a) { var d = "mixpanel"; "mixpanel" !== c && (d += "." + c); a || (d += " (stub)"); return d }; a.people.toString = function () { return a.toString(1) + ".people (stub)" }; i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
for (h = 0; h < i.length; h++)g(a, i[h]); var j = "set set_once union unset remove delete".split(" "); a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]) } } for (var d = {}, e = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++)b(j[c]); return d }; b._i.push([e, f, c])
}; b.__SV = 1.2; e = f.createElement("script"); e.type = "text/javascript"; e.async = !0; e.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ?
MIXPANEL_CUSTOM_LIB_URL : "file:" === f.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"; g = f.getElementsByTagName("script")[0]; g.parentNode.insertBefore(e, g)
}
})(document, window.mixpanel || []);

mixpanel.init(ANALYTICS_KEY, { debug: false });

var ANALYTICS_COOKIE_WHITELIST = ['user_id', 'role_id', 'role_type', 'tenant_id', 'selected_tenant_id', 'fleet_sfid', 'start_time'];

/**
 * Extracts a numeric tenant id from strings like "select_124" → 124 (integer).
 * Prefers trailing digits; otherwise uses the first run of digits in the string.
 */
function normalizeTenantIdToInteger(value) {
    if (value === undefined || value === null || value === '') return value;
    var s = String(value).trim();
    var m = s.match(/(\d+)$/);
    if (m) return parseInt(m[1], 10);
    m = s.match(/\d+/);
    return m ? parseInt(m[0], 10) : value;
}

function sanitizeAnalyticsPayload(raw) {
    var out = {};
    if (!raw) return out;
    for (var i = 0; i < ANALYTICS_COOKIE_WHITELIST.length; i++) {
        var k = ANALYTICS_COOKIE_WHITELIST[i];
        if (raw[k] !== undefined && raw[k] !== '') out[k] = raw[k];
    }
    if (out.tenant_id !== undefined) out.tenant_id = normalizeTenantIdToInteger(out.tenant_id);
    if (out.selected_tenant_id !== undefined) out.selected_tenant_id = normalizeTenantIdToInteger(out.selected_tenant_id);
    return out;
}

const analytics = {
    track: function (event, props) { //To send analytical data to Mixpanel
        var raw = this.fetchCookieAnalyticsData();
        var mixpanelUser = sanitizeAnalyticsPayload(raw);
        var t = parseFloat(mixpanelUser.start_time);
        var since_state_diff = Number.isFinite(t) ? (new Date().getTime() - t) : 0;
        var since_state_load = Math.ceil((since_state_diff / 1000) * 10) / 10;
        var superProps = Object.assign({}, props || {}, mixpanelUser, {
            since_state_load: since_state_load,
            package: 'DS2'
        });
        mixpanel.track(event, superProps);
    },
    identify: function () { //To verify the User
        if (typeof document.analyticData === 'string' && document.analyticData.indexOf('start_time=') === -1) {
            document.analyticData += ';start_time=' + new Date().getTime();
        }
        var raw = this.fetchCookieAnalyticsData();
        var mixpanelUser = sanitizeAnalyticsPayload(raw);
        if (mixpanelUser && mixpanelUser.user_id) {
            mixpanel.identify(mixpanelUser.user_id);
            mixpanel.people.set({
                user_id: mixpanelUser.user_id,
                role_id: mixpanelUser.role_id,
                role_type: mixpanelUser.role_type,
                tenant_id: mixpanelUser.tenant_id,
                selected_tenant_id: mixpanelUser.selected_tenant_id,
                fleet_sfid: mixpanelUser.fleet_sfid
            });
        } else {
            mixpanel.identify();
        }
    },
    reset: function () { //To delete the session
        document.analyticData = undefined;
        if (mixpanel.reset) {
            mixpanel.reset();
        }
    },
    fetchCookieAnalyticsData: function () { //To fetch Data from Browser Cookie
        const data = {};
        try {
            document.analyticData.split(';').forEach((x) => data[x.split('=')[0]] = x.split('=')[1]);
        } catch (er) { console.log("Error From analytics Cookie", er) }
        return data;
    }
};

Object.freeze(analytics); //To Make it immutable

document.addEventListener("DOMContentLoaded", function () { //To bind events
    const trackItems = document.querySelectorAll('[analytics-track]');
    trackItems.forEach(function (el) {
        try {
            const event = el.getAttribute('analytics-track');
            el.addEventListener('click', function () {
                analytics.track(event);
            });
        } catch (er) { console.log("Error From Analyics Event bind", er) }
    });
});

//This code for user session inactive managment-payal
var logoutTimer, popupTimer;  
  
function resetLogoutTimer() {  
    clearTimeout(logoutTimer);  
    clearTimeout(popupTimer); // clear the popupTimer  
    logoutTimer = setTimeout(logoutUser, 15*60*5000); // 15 minutes in milliseconds 15 * 60 * 1000  
  
    // Set another timeout to show the popup one minute before the user is logged out    
    popupTimer = setTimeout(function() {    
        showPopupforTimeout("You have been inactive for sometime. You will be logged out in a while");    
    }, 14*60*1000 ); // 14 minutes in milliseconds 14 * 60 * 1000    
}  
  
function logoutUser() {
  var customerKey =
    (window.meta && window.meta.page && window.meta.page.customerId) ||
    (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) ||
    null;

  var idmsLogout = window.IDMS_LOGOUT || "https://idms.netradyne.com/";

  function finish() {
    try { sessionStorage.setItem("ds2_logged_out", "1"); } catch (e) {}
    fetch("/account/logout", { method: "GET", credentials: "same-origin", cache: "no-store" })
      .catch(function () {})
      .then(function () { window.location.replace(idmsLogout); });
  }

  if (window.DS2LogoutCart) {
    var savePromise = customerKey
      ? window.DS2LogoutCart.saveCartSnapshot(customerKey)
      : Promise.resolve();
    savePromise
      .catch(function () {})
      .then(function () {
        window.DS2LogoutCart.clearSessionStorage(customerKey);
        window.DS2LogoutCart.clearAuthLocalStorage();
        window.DS2LogoutCart.clearAuthCookies();
        finish();
      });
  } else {
    finish();
  }
}
  
// Bind events to reset the timer  
document.addEventListener('mousemove', resetLogoutTimer);  
document.addEventListener('keypress', resetLogoutTimer);  
document.addEventListener('touchstart', resetLogoutTimer);  
  
// Initialize timer on page load  
resetLogoutTimer();  
